import React, { useState, useEffect, useRef, forwardRef } from "react";

import {
  Button,
  Dialog,
  Divider,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Slide,
  Grid,
  CircularProgress,
  FormControlLabel,
  Checkbox,
  Box,
  Stack,
} from "@mui/material";
import Logo from "@assets/images/logo_3.png";

import moment from "moment";

moment.updateLocale("en", {
  week: {
    dow: 1,
  },
});

import Notes from "@components/patients/Notes";
import EpisodesOfCare from "@components/patients/EpisodesOfCare";

import { useReactToPrint } from "react-to-print";

import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

import CloseIcon from "@mui/icons-material/Close";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function DischargeReport({
  isVisible,
  onCloseDischargeReport,
  dataPatient,
  dataPatientEOC,
  dataPatientObservations,
  ...props
}) {
  const [loading, setLoading] = useState(false);
  const [dataAdmitted, setDataAdmitted] = useState(null);
  const [dataDischarged, setDataDischarged] = useState(null);
  const [dataObservations, setDataObservations] = useState(null);

  useEffect(() => {
    const timeOut = setTimeout(() => {
      setLoading(false);

      const admittedEvents = dataPatientEOC.filter(
        (event) => event.event_type === "admitted"
      );

      if (admittedEvents.length > 0) {
        const latestAdmitted = admittedEvents.reduce((prev, current) =>
          new Date(prev.timestamp) > new Date(current.timestamp)
            ? prev
            : current
        );

        setDataAdmitted(latestAdmitted);
      } else {
        setDataAdmitted(null);
      }

      const dischargedEvents = dataPatientEOC.filter(
        (event) => event.event_type === "discharged"
      );

      if (dischargedEvents.length > 0) {
        const latestDischarged = dischargedEvents.reduce((prev, current) =>
          new Date(prev.timestamp) > new Date(current.timestamp)
            ? prev
            : current
        );

        if (dataPatientObservations.length > 0 && latestDischarged) {
          const observationToStore = dataPatientObservations.find(
            (observation) =>
              observation.observation_id === latestDischarged.observation_id
          );

          setDataObservations(observationToStore);
        } else {
          setDataObservations(null);
        }

        setDataDischarged(latestDischarged);
      } else {
        setDataDischarged(null);
      }
    }, 1000);

    return () => clearTimeout(timeOut);
  }, [dataPatientEOC]);

  const componentRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const isNullOrEmpty = (value) => {
    if (value === null || value === undefined) {
      return true;
    }

    if (typeof value === "string" && value.trim().toLowerCase() === "null") {
      return true;
    }

    if (Array.isArray(value) && value.length === 0) {
      return true;
    }

    if (typeof value === "string" && value.trim() === "") {
      return true;
    }

    if (typeof value === "number" && isNaN(value)) {
      return true;
    }

    return false;
  };

  const formatDate = (date) => {
    const options = { day: "2-digit", month: "2-digit", year: "numeric" };
    return new Intl.DateTimeFormat("en-GB", options).format(new Date(date));
  };

  const formatLabelDate = (value) =>
    new Date(value).toLocaleString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });

  return (
    <Dialog
      fullScreen
      open={isVisible}
      onClose={onCloseDischargeReport}
      TransitionComponent={Transition}
      PaperProps={{
        style: {
          backgroundColor: "#FFF",
          boxShadow: "none",
        },
      }}
    >
      <AppBar sx={{ position: "relative" }} color="primary">
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={onCloseDischargeReport}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
          <Typography
            sx={{ ml: 2, flex: 1 }}
            style={{ paddingLeft: 8 }}
            variant="h6"
            component="div"
          >
            {dataPatient.firstname + " " + dataPatient.surname}
          </Typography>
        </Toolbar>
      </AppBar>

      <Box
        style={{
          margin: 16,
        }}
      >
        {loading ? (
          <CircularProgress color="primary" />
        ) : (
          <>
            <Button
              variant="contained"
              color="primary"
              style={{}}
              onClick={() => {
                handlePrint();
              }}
            >
              Print Preview
            </Button>
            <Box style={{ margin: 50 }} ref={componentRef}>
              <Grid
                container
                spacing={1}
                style={{ display: "flex", alignItems: "center" }}
              >
                <Grid
                  item
                  xs={12}
                  md={12}
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    //padding: 15,
                  }}
                >
                  <img src={Logo} alt="Logo" style={{ height: 55 }} />
                </Grid>

                <Grid
                  item
                  xs={12}
                  md={12}
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  <Typography
                    variant="h6"
                    style={{ textAlign: "center", fontWeight: "bold" }}
                  >
                    {dataPatient.hospital_name + ", " + dataPatient.ward_name}
                  </Typography>
                </Grid>

                <Grid
                  item
                  xs={12}
                  md={12}
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  <Typography
                    variant="h6"
                    style={{ textAlign: "center", fontWeight: "bold" }}
                  >
                    Discharge Summary
                  </Typography>
                </Grid>

                {!isNullOrEmpty(dataDischarged) ? (
                  <>
                    {/* <Grid
                      item
                      xs={12}
                      md={12}
                      style={{ display: "flex", justifyContent: "left" }}
                    >
                      <Typography style={{ fontWeight: "bold" }}>
                        {"Admitted: " +
                          moment(dataAdmitted.date).format("DD/MM/YYYY")}
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      md={12}
                      style={{
                        display: "flex",
                        justifyContent: "left",
                        paddingTop: 0,
                        marginBottom: 15,
                      }}
                    >
                      <Typography style={{ fontWeight: "bold" }}>
                        {"Discharged: " +
                          moment(dataAdmitted.date).format("DD/MM/YYYY")}
                      </Typography>
                    </Grid> */}

                    <Grid
                      item
                      xs={12}
                      md={12}
                      style={{
                        display: "flex",
                        justifyContent: "left",
                        flexDirection: "column",
                        marginBottom: 20,
                      }}
                    >
                      <Typography style={{ fontWeight: "bold" }}>
                        Patient Information
                      </Typography>
                      <Divider
                        orientation="horizontal"
                        variant="fullWidth"
                        style={{ padding: 2, marginBottom: 5 }}
                      />

                      <Typography>
                        {"Name: " +
                          dataPatient.firstname +
                          " " +
                          dataPatient.surname}
                      </Typography>
                      <Typography>
                        {"Date of Birth: " +
                          moment(dataPatient.dob).format("DD/MM/YYYY")}
                      </Typography>
                      <Typography>
                        {"Medical Record Number: " + dataPatient.mrn}
                      </Typography>
                      <Typography>
                        {"Date Admitted: " +
                          moment(dataAdmitted.date).format("DD/MM/YYYY")}
                      </Typography>
                      <Typography>
                        {"Date Discharged: " +
                          moment(dataDischarged.date).format("DD/MM/YYYY")}
                      </Typography>
                    </Grid>

                    <Grid
                      item
                      xs={12}
                      md={12}
                      style={{
                        display: "flex",
                        justifyContent: "left",
                        flexDirection: "column",
                        marginBottom: 20,
                      }}
                    >
                      <Typography style={{ fontWeight: "bold" }}>
                        Transfer History
                      </Typography>
                      <Divider
                        orientation="horizontal"
                        variant="fullWidth"
                        style={{ padding: 2, marginBottom: 5 }}
                      />

                      <Typography>{dataDischarged.transfer_history}</Typography>
                    </Grid>

                    <Grid
                      item
                      xs={12}
                      md={12}
                      style={{
                        display: "flex",
                        justifyContent: "left",
                        flexDirection: "column",
                        marginBottom: 20,
                      }}
                    >
                      <Typography style={{ fontWeight: "bold" }}>
                        Diagnosis
                      </Typography>
                      <Divider
                        orientation="horizontal"
                        variant="fullWidth"
                        style={{ padding: 2, marginBottom: 5 }}
                      />

                      <Typography>{dataDischarged.diagnosis}</Typography>
                    </Grid>

                    <Grid
                      item
                      xs={12}
                      md={12}
                      style={{
                        display: "flex",
                        justifyContent: "left",
                        flexDirection: "column",
                        marginBottom: 20,
                      }}
                    >
                      <Typography style={{ fontWeight: "bold" }}>
                        Medical History
                      </Typography>
                      <Divider
                        orientation="horizontal"
                        variant="fullWidth"
                        style={{ padding: 2, marginBottom: 5 }}
                      />

                      <Typography>{dataDischarged.medical_history}</Typography>
                    </Grid>

                    <Grid
                      item
                      xs={12}
                      md={12}
                      style={{
                        display: "flex",
                        justifyContent: "left",
                        flexDirection: "column",
                        marginBottom: 20,
                      }}
                    >
                      <Typography style={{ fontWeight: "bold" }}>
                        Allergies
                      </Typography>
                      <Divider
                        orientation="horizontal"
                        variant="fullWidth"
                        style={{ padding: 2, marginBottom: 5 }}
                      />

                      <Typography>{dataDischarged.allergies}</Typography>
                    </Grid>

                    <Grid
                      item
                      xs={12}
                      md={12}
                      style={{
                        display: "flex",
                        justifyContent: "left",
                        flexDirection: "column",
                        marginBottom: 20,
                      }}
                    >
                      {!isNullOrEmpty(dataObservations) ? (
                        <Typography style={{ fontWeight: "bold" }}>
                          {"Vitals (latest vitals taken at " +
                            moment(dataObservations.timestamp).format(
                              "DD/MM/YYYY hh:mm a"
                            ) +
                            ")"}
                        </Typography>
                      ) : (
                        <Typography style={{ fontWeight: "bold" }}>
                          {"Vitals"}
                        </Typography>
                      )}
                      <Divider
                        orientation="horizontal"
                        variant="fullWidth"
                        style={{ padding: 2, marginBottom: 5 }}
                      />

                      {/* <Typography>
                        {"RR: " + dataObservations.resp_rate}
                      </Typography>
                      <Typography>
                        {"SpO2: " + dataObservations.oximeter}
                      </Typography>
                      <Typography>
                        {"BP: " +
                          dataObservations.sys +
                          "/" +
                          dataObservations.dia}
                      </Typography>
                      <Typography>{"HR: " + dataObservations.bpm}</Typography>
                      <Typography>
                        {"Temperature: " + dataObservations.temperature}
                      </Typography>
                      <Typography>
                        {"EWS: " + dataObservations.news_score}
                      </Typography> */}

                      {!isNullOrEmpty(dataObservations) ? (
                        <Typography>
                          {"RR: " +
                            dataObservations.resp_rate +
                            ", " +
                            "Sats: " +
                            dataObservations.oximeter +
                            "% at RA, " +
                            "BP: " +
                            dataObservations.sys +
                            "/" +
                            dataObservations.dia +
                            ", " +
                            "HR: " +
                            dataObservations.bpm +
                            "b/m, " +
                            "Temperature: " +
                            dataObservations.temperature +
                            "°C, " +
                            "EWS: " +
                            dataObservations.news_score}
                        </Typography>
                      ) : (
                        <Typography>Vitals are never taken</Typography>
                      )}
                    </Grid>

                    <Grid
                      item
                      xs={12}
                      md={12}
                      style={{
                        display: "flex",
                        justifyContent: "left",
                        flexDirection: "column",
                        marginBottom: 20,
                      }}
                    >
                      <Typography style={{ fontWeight: "bold" }}>
                        Medications
                      </Typography>
                      <Divider
                        orientation="horizontal"
                        variant="fullWidth"
                        style={{ padding: 2, marginBottom: 5 }}
                      />

                      <Typography>
                        {dataDischarged.medications_at_discharge}
                      </Typography>
                    </Grid>

                    <Grid
                      item
                      xs={12}
                      md={12}
                      style={{
                        display: "flex",
                        justifyContent: "left",
                        flexDirection: "column",
                        marginBottom: 20,
                      }}
                    >
                      <Typography style={{ fontWeight: "bold" }}>
                        Discharge Plan
                      </Typography>
                      <Divider
                        orientation="horizontal"
                        variant="fullWidth"
                        style={{ padding: 2, marginBottom: 5 }}
                      />

                      <Typography>{dataDischarged.discharged_plan}</Typography>
                    </Grid>

                    {dataDischarged.admission_rejection === 1 && (
                      <Grid
                        item
                        xs={12}
                        md={12}
                        style={{
                          display: "flex",
                          justifyContent: "left",
                          flexDirection: "column",
                          marginBottom: 20,
                        }}
                      >
                        <Typography style={{ fontWeight: "bold" }}>
                          Declined Admission Reason
                        </Typography>
                        <Divider
                          orientation="horizontal"
                          variant="fullWidth"
                          style={{ padding: 2, marginBottom: 5 }}
                        />

                        {dataDischarged.admission_decline === "Other" ? (
                          <Typography>
                            {dataDischarged.admission_decline_other}
                          </Typography>
                        ) : (
                          <Typography>
                            {dataDischarged.admission_decline}
                          </Typography>
                        )}
                      </Grid>
                    )}

                    <Grid
                      item
                      xs={12}
                      md={12}
                      style={{
                        display: "flex",
                        justifyContent: "left",
                        flexDirection: "column",
                        marginTop: 20,
                        marginBottom: 5,
                      }}
                    >
                      <Typography>
                        {"Prepared by: " +
                          dataDischarged.prepared_by_name +
                          " (" +
                          dataDischarged.prepared_by_title_position +
                          ")"}
                      </Typography>
                    </Grid>

                    <Grid
                      item
                      xs={12}
                      md={12}
                      style={{
                        display: "flex",
                        justifyContent: "left",
                        //flexDirection: "column",
                        marginTop: 10,
                      }}
                    >
                      <Stack direction="row" spacing={2}>
                        <Typography style={{ fontWeight: "bold" }}>
                          Signature
                        </Typography>
                        <Typography>___________________________</Typography>

                        <Typography style={{ fontWeight: "bold" }}>
                          Date:
                        </Typography>
                        <Typography>___________________________</Typography>
                      </Stack>
                    </Grid>
                  </>
                ) : (
                  <Grid
                    item
                    xs={12}
                    md={12}
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    <Typography variant="caption">
                      No records to display
                    </Typography>
                  </Grid>
                )}
              </Grid>
            </Box>
          </>
        )}
      </Box>
    </Dialog>
  );
}
